module.exports = __webpack_public_path__ + "static/img/03.032d91f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/peterschmid/03.jpg
// module id = 437
// module chunks = 1